import { useEffect } from 'react';
import { useRevalidator } from 'react-router-dom';

/**
 * Revalidates the current route loader when offline sync completes.
 * Use in any page component that displays data affected by offline operations
 * (orders, actions, accidents, campaigns, etc.).
 */
export function useRevalidateOnSync() {
  const revalidator = useRevalidator();

  useEffect(() => {
    const handleSyncComplete = () => revalidator.revalidate();
    window.addEventListener('offline-sync-complete', handleSyncComplete);
    return () =>
      window.removeEventListener('offline-sync-complete', handleSyncComplete);
  }, [revalidator]);
}
